import { useState } from 'react';
import { I18n } from 'aws-amplify';

import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';

import awsmobile from '@/aws-exports';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import SpecialCharactersEmoji from '@/component/formManagement/fieldUI/SpecialCharactersEmoji'; 
import { getRichTextFieldContent } from '@/component/ticketList/handler/TicketHandler';
import { uploadFileToS3InTMPFolder } from '@/common/utils/UploadFileUtil';
import { getLinkDownloadFileFromS3 } from '@/component/common/FileUploaded';
import editorConfiguration from '../../formManagement/fieldUI/editorConfiguration'

import LoadingPanel from '@/component/common/LoadingPanel';

const getImageSrc = (htmlString) => {
    let doc;
    try {
        doc = new DOMParser().parseFromString(htmlString, "text/html");
    } catch (e) {
        return [];
    }
    
    const img = doc.querySelectorAll("img");
    const imgSrcList = [];
    if (img) {
        doc.querySelectorAll('img').forEach((imgElement) => {
        imgSrcList.push(imgElement.getAttribute('src'));
        });
    }
    return imgSrcList;
}

const replaceOldLinkImg = defaultValue => {
    try {
        if (defaultValue) defaultValue = defaultValue.replace(/\\\n/g, ' <br /> ').replace(/\\n/g, ' <br /> ');
    } catch (error) {
        
    }
    let stringCopy = (' ' + defaultValue).slice(1);

    let imgSrcList = getImageSrc(defaultValue);
    imgSrcList = imgSrcList.filter(src => src);
    if(Utils.isEmptyArray(imgSrcList)) {
        return stringCopy;
    }

    for (let i = 0; i < imgSrcList.length; i++) {
        let indexOfImage = imgSrcList[i].indexOf(
            `https://${awsmobile.aws_user_files_s3_bucket}.s3`
        );
        if (indexOfImage !== -1) {
            const startStr = '/public/';
            const endStr = '?';

            const startIndex = imgSrcList[i].indexOf(startStr) + startStr.length;
            const endIndex = imgSrcList[i].indexOf(endStr, startIndex);

            const resultKey = imgSrcList[i].substring(startIndex, endIndex);
            
            let fileUpload = {
                fileUrl: resultKey,
                type: Constant.S3_FILE_TYPE.TICKET_FILE
            }
            let link = getLinkDownloadFileFromS3(fileUpload, {}, null, null, false, true);
            let linkNeedReplace = `\\"${link}\\"`;
            stringCopy = stringCopy.replace(imgSrcList[i], linkNeedReplace);
        }
    }
    return stringCopy;
};

function EmailRichtext({
    label = '',
    disable = true,
    richtextValue,
    setRichtextValue,
    setIsEdited,
    isRequired = false,
    isValidateWhenBlur = false,
    isCustomerMail = false,
    isDisableLink = false,
    isDisableEdit = false,
    onclickReplyTicket = ()=>{}
}) {
    const [isLoadingUploadFile, setIsLoadingUploadFile] = useState(false);
    let ckEditorState = '';
    if (richtextValue.value) {
        ckEditorState = Utils.isValidJSONString(replaceOldLinkImg(richtextValue.value)) ? JSON.parse(richtextValue.value) : richtextValue.value
    }
    let ckEditorId = Utils.generateRandomStr();
    
    function uploadImageAdapterPlugin(editor) {
        editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
            return {
                upload: async () => {
                    return loader.file.then((file)=>{
                        setIsLoadingUploadFile(true)
                        return file
                    }).then(async (file) => {
                        const result = await uploadFileToS3InTMPFolder(file);
                        const fileUpload = {
                            fileUrl: result.key,
                            type: Constant.S3_FILE_TYPE.TICKET_FILE
                        };
                        const link = await getLinkDownloadFileFromS3(fileUpload, {}, null, null, false, true);
                        return {default: `${link}`};
                    }).finally( ()=>{
                       setTimeout(()=> setIsLoadingUploadFile(false), 600)
                    });
                }
            };
        };
    }

    const handleOnChangeCKEditor = (event, editor) => {
        if (disable) return;
        const htmlContent = editor.getData();
        
        let contentText = getRichTextFieldContent(htmlContent);
        let newErrMsg = '';
        if (Utils.isEmptyString(contentText) && isRequired) {
            newErrMsg = I18n.get('COMM01MSG11')
        } else {
            const validateSizeRichtextContent = JSON.stringify(htmlContent)
            newErrMsg = Utils.validateSizeOfFieldTicket(validateSizeRichtextContent);
        }

        const newValue = htmlContent

        setRichtextValue(prev => {
            if (!isValidateWhenBlur) {
                if (prev.value === newValue) {
                    return {value: newValue, error: ''}
                }
                setIsEdited(Utils.isEmptyString(newErrMsg))
            }

            return {value: newValue, error: newErrMsg}
        })
    };

    const handleOnBlurCKEditor = (event, editor) => {
        if (disable || !isValidateWhenBlur) return;
        const htmlContent = editor.getData();
        
        let contentText = getRichTextFieldContent(htmlContent);
        let newErrMsg = '';
        if (Utils.isEmptyString(contentText) && isRequired) {
            newErrMsg = I18n.get('COMM01MSG11')
        } else {
            const validateSizeRichtextContent = JSON.stringify(htmlContent)
            newErrMsg = Utils.validateSizeOfFieldTicket(validateSizeRichtextContent);
        }
        setIsEdited(Utils.isEmptyString(newErrMsg))


        setRichtextValue(prev => {
            return {value: htmlContent, error: newErrMsg}
        })
    }

    return (
        <div className="project-email-setting-group">
            <LoadingPanel isLoading={isLoadingUploadFile}/>
            <div className="mailBody-title-wrap">
                <div className="embeddedCode-label margin-bottom-5">
                    <span>{label}</span>
                    {isRequired && <span className="required">*</span>}
                </div>
                {/**get from <MailBodyViewOnly/>. using richtext render so we get it from that to here */}
                {isCustomerMail && (
                    <span
                        className={`send-msg-hyper-link ${
                            isDisableLink || isDisableEdit ? 'send-msg-hyper-link-disable' : ''
                        }`}
                        onClick={() => {
                            if (isDisableLink || isDisableEdit) return;
                            onclickReplyTicket();
                        }}
                    >
                        このメッセージに返信
                    </span>
                )}
            </div>
            <div className="email-response-address-input-wrap">
                <div className={`email-signature-ck-editor-wrapper ${richtextValue.error ? ' editor-err': ''}`}>
                    <div
                        id={`ckbox-${ckEditorId}`}
                        data-cy="richtext-editor"
                        className={`editor sdesk-editor ${richtextValue.error ? ' editor-err': ''} ${disable ? 'ckeditor5-readonly' : ''}`}
                    >
                        {typeof window?.CKEDITOR?.ClassicEditor != 'undefined' && (
                            <CKEditor
                                disabled={disable}
                                editor={window.CKEDITOR.ClassicEditor}
                                data={ckEditorState}
                                config={{
                                    ...editorConfiguration,
                                    extraPlugins: [SpecialCharactersEmoji, uploadImageAdapterPlugin]
                                }}
                                onReady={editor => {
                                    editor.ui.view.toolbar.element.style.display = 'none';
                                    // Init fontSize default
                                    const fontSize = editor.commands.get('fontSize');
                                    fontSize.execute({ value: '14px' });

                                    // Init fontFamily default
                                    const fontFamily = editor.commands.get('fontFamily');
                                    fontFamily.execute({ value: 'Arial, Helvetica, sans-serif' });
                                    editor.execute('fontSize', { value: '14px' });
                                    editor.execute('fontFamily', {
                                        value: 'Arial, Helvetica, sans-serif'
                                    });

                                    // editor.model.document.on('change', (event, editorData) => {
                                    //     handleOnChangeCKEditor(event, editor);
                                    // });
                                }}
                                onChange={(event, editor) => handleOnChangeCKEditor(event, editor)}
                                onBlur={(event, editor) => handleOnBlurCKEditor(event, editor)}

                                onFocus={(event, editor) => {
                                    window.editor = editor;
                                    document
                                        .querySelectorAll(`.editor .ck.ck-sticky-panel__content > .ck.ck-toolbar[aria-label="Editor toolbar"]`)
                                        .forEach(el => {el.style.display = 'none';});
                                    editor.ui.view.toolbar.element.style.display = 'block';
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>
            {richtextValue.error && <p className="email-signature-error-text">{richtextValue.error}</p>}
        </div>
    );
}

export default EmailRichtext;
